import { render, staticRenderFns } from "./SaleTypeCalendarHoverSettings.vue?vue&type=template&id=2b0394f6&scoped=true"
import script from "./SaleTypeCalendarHoverSettings.vue?vue&type=script&lang=ts"
export * from "./SaleTypeCalendarHoverSettings.vue?vue&type=script&lang=ts"
import style0 from "./SaleTypeCalendarHoverSettings.vue?vue&type=style&index=0&id=2b0394f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0394f6",
  null
  
)

export default component.exports